import { useRef, useEffect, useState } from 'react';

function useTimeout(callback: () => void, delay: number) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    function callCallback() {
      callbackRef.current();
    }

    const timeout = window.setTimeout(callCallback, delay);

    return () => {
      window.clearTimeout(timeout);
    };
  }, []);
}

function useOverTimeout(delay: number): boolean {
  const [overtime, setOvertime] = useState(false);

  useTimeout(() => setOvertime(true), delay);

  return overtime;
}

export { useTimeout, useOverTimeout };
